import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { observer } from 'mobx-react';
import {
  generateLoanDetailsTableData,
  mapDownloadableQuoteData,
} from '../../utils/summaryUtils';
import { useStore } from '@roc/client-portal-shared/hooks';
import { IQuoteTypeStore } from '../../stores/common/iQuoteTypeStore';

const useStyles = makeStyles(() => ({
  noBorders: {
    border: 'none',
  },
  darkCell: {
    backgroundColor: '#E4E8EB',
  },
  brightCell: {
    backgroundColor: '#FCFCFC',
  },
  boldCell: {
    fontWeight: 'bold',
    color: 'black',
  },
}));

interface FeesDetailsTableProps {
  store: IQuoteTypeStore;
}

export const FeesDetailsTable = observer(({ store }: FeesDetailsTableProps) => {
  const classes = useStyles();

  const property = store.propertiesStore.getProperties()[0];
  const calculatedFields = store.loanEconomicsStore.calculateFields();

  function getClassNames(categoryIdx) {
    return `${classes.noBorders} ${
      categoryIdx % 2 === 0 ? classes.darkCell : classes.brightCell
    }`;
  }

  const data = mapDownloadableQuoteData(store);
  const feesDetails = generateLoanDetailsTableData(
    data,
    property?.loanPurpose,
    store.loanSubtype
  );

  const lastRowBackgroundClass =
    feesDetails.categories.length % 2 === 0
      ? classes.darkCell
      : classes.brightCell;

  return (
    <TableContainer style={{ border: '1px solid #ddd' }}>
      <Table>
        <TableBody>
          {feesDetails.categories.map((category, categoryIdx) =>
            category.fees.map((fee, feeIdx) => (
              <TableRow key={fee.name}>
                <TableCell className={getClassNames(categoryIdx)}>
                  {feeIdx === 0 && category.name}
                </TableCell>
                <TableCell
                  className={`${getClassNames(categoryIdx)} ${
                    classes.boldCell
                  }`}
                >
                  {fee.name}
                </TableCell>
                <TableCell className={getClassNames(categoryIdx)} align="right">
                  {fee.amount}
                </TableCell>
                <TableCell
                  className={`${getClassNames(categoryIdx)} ${
                    classes.boldCell
                  }`}
                  align="right"
                >
                  {feeIdx === category.fees.length - 1 && category.total}
                </TableCell>
              </TableRow>
            ))
          )}
          <TableRow>
            <TableCell className={lastRowBackgroundClass}></TableCell>
            <TableCell className={lastRowBackgroundClass}></TableCell>
            <TableCell
              className={`${lastRowBackgroundClass} ${classes.boldCell}`}
              align="right"
            >
              TOTAL:
            </TableCell>
            <TableCell
              className={`${lastRowBackgroundClass} ${classes.boldCell}`}
              align="right"
            >
              {feesDetails.total}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
});
